import { Pagination, Stack } from "@mui/material";

export default function CustomPagination({
  totalItems,
  currentPage,
  handleNextPage,
}) {
  return (
    <div className='flex justify-center items-center my-5'>
      <Stack>
        <Pagination
          sx={{
            "& .MuiPaginationItem-root": {
              "&.Mui-selected": {
                backgroundColor: "var(--primary-color)",
                color: "white",
              },
              "&:hover": {
                backgroundColor: "var(--primary2-color)",
                color: "white",
              },
            },
          }}
          count={totalItems}
          page={currentPage}
          onChange={handleNextPage}
        />
      </Stack>
    </div>
  );
}
